import React, { useState, useEffect } from 'react';
import api from '../api';
import DashboardNav from './DashboardNav';
import LoadingSpinner from './LoadingSpinner';
import './AttendanceLog.css';

const AttendanceLog = () => {
  const [attendance, setAttendance] = useState([]);
  const [filters, setFilters] = useState({
    date: '',
    bus: '',
    event: '',
    studentName: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const res = await api.get('/attendance', {
          headers: {
            'x-auth-token': token,
          },
          params: filters, // Pass filters as query parameters
        });
        // Extract the data array from the response
        console.log('Attendance API Response:', res.data);
        const attendanceData = res.data?.data || res.data || [];
        console.log('Processed attendance data:', attendanceData);
        setAttendance(Array.isArray(attendanceData) ? attendanceData : []);
      } catch (err) {
        console.error('Error fetching attendance log:', err.response ? err.response.data : err.message);
        setError('Failed to load attendance log. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchAttendance();
  }, [filters]); // Re-fetch when filters change

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="attendance-log-container">
      <header className="attendance-log-header">
        <h1>Daily Attendance Log</h1>
        <DashboardNav />
      </header>
      <div className="filters">
        <div className="filter-group">
          <label htmlFor="date-picker">Date:</label>
          <input
            type="date"
            id="date-picker"
            name="date"
            value={filters.date}
            onChange={handleFilterChange}
          />
        </div>
        <div className="filter-group">
          <label htmlFor="bus-dropdown">Bus:</label>
          <select
            id="bus-dropdown"
            name="bus"
            value={filters.bus}
            onChange={handleFilterChange}
          >
            <option value="">All Buses</option>
            {/* Map bus options here */}
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="event-dropdown">Event:</label>
          <select
            id="event-dropdown"
            name="event"
            value={filters.event}
            onChange={handleFilterChange}
          >
            <option value="">All Events</option>
            <option value="boarded">Boarded</option>
            <option value="deboarded">Deboarded</option>
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="student-search">Student Name:</label>
          <input
            type="text"
            id="student-search"
            name="studentName"
            placeholder="Search by student name"
            value={filters.studentName}
            onChange={handleFilterChange}
          />
        </div>
      </div>
      
      {error && (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      )}
      
      <div className="attendance-list">
        {isLoading ? (
          <LoadingSpinner size="medium" message="Loading attendance log..." />
        ) : (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Bus</th>
                  <th>Student/ID</th>
                  <th>Event</th>
                </tr>
              </thead>
              <tbody>
                {attendance.length > 0 ? (
                  attendance.map((record) => (
                    <tr key={record._id}>
                      <td>{new Date(record.timestamp).toLocaleString()}</td>
                      <td>{record.bus ? record.bus.busNumber : 'N/A'}</td>
                      <td>{record.student ? `${record.student.name} (${record.student.studentId})` : 'N/A'}</td>
                      <td>{record.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                      No attendance records found for the selected filters.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default AttendanceLog;
